import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation BrandGroupListPage_DeleteBrandGroup($brandGroupId: Int!) {
    deleteBrandGroup(brandGroupId: $brandGroupId) {
      result
    }
  }
`)
type Data = ResultOf<typeof document>
type Variables = VariablesOf<typeof document>

export const useDeleteBrandGroupMutation = (
  options: Omit<
    UseMutationOptions<Data, unknown, Variables['brandGroupId'], unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (brandGroupId) =>
      graphQLRequest({ document, variables: { brandGroupId } }),
    ...options,
  })
}
